import { configFactory } from './utils';

export const { getConfig } = configFactory();
